import React from 'react'
import { Button } from '@sainsburys-tech/bolt'

import * as Styled from './AlternativeCollectionBox.styles'

export const AlternativeStoreButton = ({ collectionProps, updateIsInitialMount, chooseAlternativeStore }) => (
  <Styled.FulfilmentActionRow data-test='alternative-store-CTA'>
    <Button
      onClick={event => chooseAlternativeStore(event, collectionProps, updateIsInitialMount)}
      kind='secondary'
      data-test='select-store-button'
      small
    >
      Select Store
    </Button>
  </Styled.FulfilmentActionRow>
)
